<div class="login-container">
  <!-- Left Panel - Branding and Features -->
  <div class="branding-panel">
    <div class="branding-content">
      <!-- Header with Logo -->
      <div class="branding-header">
        <div class="logo-container">
          <div class="logo-icon">
              <img src="../../../assets/favicon.png" alt="iTrakSys" class="logo-icon">
          </div>
          <div class="brand-info">
            <h1 class="brand-name">iTrakSys</h1>
            <p class="brand-tagline">Medical Inventory Management Platform</p>
          </div>
        </div>
      </div>

      <!-- Main Heading -->
      <div class="main-heading">
        <h2 class="hero-title">Streamline Your Medical Inventory Operations</h2>
        <p class="hero-description">Advanced tracking, real-time monitoring, and intelligent analytics for medical device inventory management.</p>
      </div>


      <!-- Feature Cards -->
      <div class="features-section">
        <div class="feature-card blue">
          <div class="feature-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 20V10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 20V4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 20V14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="feature-content">
            <h3 class="feature-title">Real-Time Analytics</h3>
            <p class="feature-description">Monitor inventory levels, track usage patterns, and generate comprehensive reports.</p>
          </div>
        </div>
        <div class="feature-card green">
          <div class="feature-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22S8 18 8 12V5L12 3L16 5V12C16 18 12 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="feature-content">
            <h3 class="feature-title">Secure Access Control</h3>
            <p class="feature-description">Role-based permissions, audit trails, and compliance with medical regulations.</p>
          </div>
        </div>
        <div class="feature-card purple">
          <div class="feature-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="feature-content">
            <h3 class="feature-title">RFID Integration</h3>
            <p class="feature-description">Seamless RFID tracking for accurate inventory management and asset monitoring.</p>
          </div>
        </div>
        <div class="feature-card orange">
          <div class="feature-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 3H21V21H3V3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 9H15V15H9V9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M3 9H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M3 15H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="feature-content">
            <h3 class="feature-title">Smart Workflows</h3>
            <p class="feature-description">Automated processes and intelligent routing for efficient inventory operations.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Panel - Login Form -->
  <div class="login-panel">
    <div class="login-card">
      <div class="login-header">
        <h2 class="login-title">Welcome Back</h2>
        <p class="login-subtitle">Sign in to access your dashboard</p>
      </div>

      <form #f="ngForm" name="form" (ngSubmit)="f.form.valid && login(f.value)" novalidate class="login-form">
        <!-- Username Field -->
        <div class="form-field">
          <label for="username" class="field-label">Username</label>
          <div class="input-wrapper">
            <div class="input-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>
            <input 
              type="text" 
              id="username"
              name="username" 
              #username="ngModel" 
              ngModel 
              class="form-input"
              placeholder="Enter your username"
              [ngClass]="{ 'is-invalid': f.submitted && username.invalid }" 
              required
            >
          </div>
          <div *ngIf="f.submitted && username.invalid" class="invalid-error-msg">
            <div *ngIf="username.errors.required">Username is required</div>
          </div>
        </div>

        <!-- Password Field -->
        <div class="form-field">
          <label for="password" class="field-label">Password</label>
          <div class="input-wrapper">
            <div class="input-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                <circle cx="12" cy="16" r="1" stroke="currentColor" stroke-width="2"/>
                <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>
            <input 
              [type]="showPassword() ? 'text' : 'password'" 
              id="password"
              name="password" 
              #password="ngModel" 
              ngModel 
              class="form-input"
              placeholder="Enter your password"
              [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" 
              required
            >
            <button 
              type="button" 
              class="password-toggle" 
              (click)="showPassword.set(!showPassword())"
              tabindex="-1"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="!showPassword()">
                <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2"/>
                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
              </svg>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="showPassword()">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20C5 20 1 12 1 12A18.45 18.45 0 0 1 5.06 5.06L17.94 17.94Z" stroke="currentColor" stroke-width="2"/>
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4C19 4 23 12 23 12A18.5 18.5 0 0 1 18.1 18.76L9.9 4.24Z" stroke="currentColor" stroke-width="2"/>
                <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
          </div>
          <div *ngIf="f.submitted && password.invalid" class="invalid-error-msg">
            <div *ngIf="password.errors.required">Password is required</div>
          </div>
          <p *ngIf="errorMsg !=='' && !(f.submitted && password.invalid)" class="invalid-error-msg">*{{errorMsg}}</p>
        </div>

        <!-- Keep me signed in -->
        <div class="form-options">
          <label class="checkbox-wrapper">
            <input type="checkbox" class="remember-checkbox">
            <span class="checkmark"></span>
            <span class="checkbox-label">Keep me signed in</span>
          </label>
        </div>

        <!-- Submit Button -->
        <button type="submit" class="login-button">
          <span>Sign In</span>
        </button>

        <!-- Security Message -->
        <div class="security-message">
          <span>Secured with enterprise-grade encryption</span>
        </div>
      </form>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer">
    <p class="copyright">© 2024 iTrakSys. All rights reserved.</p>
  </div>

  <app-toast-message></app-toast-message>
</div>